<template>
  <!-- v-if="data" -->
  <div class="til">
    <img src="../assets/formula.png" alt="" />
    <span> {{ tilName }}</span>
  </div>

  <div>
    <a-descriptions title="" bordered size="small">
      <a-descriptions-item label="给药剂量（mg）">
        <a-input-number
          v-model:value="data.dose"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="给药间隔（h）">
        <a-input-number
          v-model:value="data.quaque"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="输注时间（h）">
        <a-input-number
          v-model:value="data.injectionTime"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="血药浓度（mg/L）">
        <a-input-number
          v-model:value="data.monitorings[0].concentration"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="测量时间（给药开始后n小时）" :span="2">
        <a-input-number
          v-model:value="data.monitorings[0].time"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="血药浓度（mg/L）">
        <a-input-number
          v-model:value="data.monitorings[1].concentration"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="测量时间（给药开始后n小时）" :span="2">
        <a-input-number
          v-model:value="data.monitorings[1].time"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="滴注速率常数（k0）" :span="1">
        <a-input-number
          v-model:value="data.advice.k0"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="表观分布容积（vd）" :span="1">
        <a-input-number
          v-model:value="data.advice.vd"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
      <a-descriptions-item label="最低抑菌浓度（MIC）" :span="1">
        <a-input-number
          v-model:value="data.advice.mic"
          type="number"
          size="small"
          style="width: 100%"
        />
      </a-descriptions-item>
    </a-descriptions>
    <br />
    <a-space size="large" direction="vertical" style="float: right">
      <a-button type="primary" size="large" @click="onSolve">
        <template v-slot:icon>
          <CalculatorOutlined />
        </template>
        规划求解
      </a-button>
      <!-- @click="onDownload" -->
      <!-- <a-button type="primary" size="large">
        <template v-slot:icon>
          <DownloadOutlined />
        </template>
        报告下载
      </a-button> -->
    </a-space>
    <a-row type="flex" v-if="res.results">
      <a-col :flex="1">
        <a-table
          :row-style="{ border: 'none' }"
          :columns="columns"
          :data-source="resultDataSource"
          size="small"
          :rowKey="(record) => record.condition"
          :pagination="false"
        >
        </a-table>
      </a-col>
      <a-col :flex="1">
        <v-echarts
          :option="option"
          :loadingOption="loadingOption"
          ref="mychart"
          style="
            width: 80%;
            height: 100%;
            padding: 7px 0;
            margin: auto;
            border-radius: 15px;
            background: #ffffff;
            box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
          "
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import {
  CalculatorOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { VEcharts } from "vue3-echarts";
import CurveFitting from "@/utils/curveFitting";
import { createVNode } from "vue";
import { Modal } from "ant-design-vue";

const columns = [
  {
    title: "",
    dataIndex: "condition",
  },
  {
    title: "敏感",
    width: "20%",
    dataIndex: "sensitive",
  },
  {
    title: "中介",
    width: "20%",
    dataIndex: "resistant",
  },
  {
    title: "耐药",
    width: "20%",
    dataIndex: "mediated",
  },
];

export default {
  components: {
    CalculatorOutlined,
    DownloadOutlined,
    VEcharts,
  },
  setup() {
    const i18n = useI18n();
    return {
      i18n,
    };
  },
  data() {
    return {
      til: "",
      tilName: "",
      data: {
        dose: "",
        quaque: "",
        injectionTime: "",
        monitorings: [
          {
            concentration: "",
            time: "",
          },
          {
            concentration: "",
            time: "",
          },
        ],
        advice: {
          k0: "",
          vd: "",
          mic: "",
        },
      },
      columns,
      resultDataSource: [
        {
          condition: "MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
        {
          condition: "t > MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
        {
          condition: "%T > MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
        {
          condition: "4 x MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
        {
          condition: "t > 4 x MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
        {
          condition: "%T > 4 x MIC",
          sensitive: "NaN",
          resistant: "NaN",
          mediated: "NaN",
        },
      ],
      option: null,
      loadingOption: {
        text: "加载中",
        color: "#1890FF",
      },
      res: {},
    };
  },
  created() {
    const drugId = this.$route.params.drugId;
    const drugName = this.$route.params.drugName;
    this.tilName = drugName;
    // console.log(this.tilName, "tilName");
    // if (drugId == 1) {
    //   this.til = "亚胺培南药物计算";
    // } else if (drugId == 2) {
    //   this.til = "美罗培南药物计算";
    // } else if (drugId == 3) {
    //   this.til = "哌拉西林药物计算";
    // }
  },
  methods: {
    ...mapActions("drug", ["programmingSolver"]),
    onSolveSucess() {
      this.$message.success("求解成功");
    },
    onSolveError(error) {
      console.log("onSolveError: ", error);

      const contents = [];

      if (error.dose) {
        contents.push("给药剂量");
      }

      if (error.quaque) {
        contents.push("给药间隔");
      }

      if (error.injectionTime) {
        contents.push("输注时间");
      }

      if (error.monitorings) {
        contents.push("血药浓度、测量时间");
      }

      let message = "请检查";
      for (let i = 0; i < contents.length; i += 1) {
        message += contents[i];

        if (i !== contents.length - 1) {
          message += "、";
        }
      }

      this.$message.error(message);
    },
    async onSolve() {
      console.log(this.data, "入参");

      const data = JSON.parse(JSON.stringify(this.data));

      // if (!data.advice.k0) {
      //   // set k0 to 0 in case of API errors
      //   data.advice.k0 = 0;
      // }

      // if (!data.advice.vd) {
      //   // set vd to 0 in case of API errors
      //   data.advice.vd = 0;
      // }

      // if (data.pharmacokinetic.id) {
      //   try {
      //     await this.updatePharmacokinetic(data.pharmacokinetic);

      //     this.onSolveSucess();
      //   } catch (error) {
      //     this.onSolveError(error);
      //   }
      // } else {
      // data.pharmacokinetic.report = data.id;
      try {
        const res = await this.programmingSolver(data);
        this.res = res;
        const tableResults = res.results;

        let i = 0;
        for (i = 0; i < tableResults.length; i += 3) {
          const dataSource = this.resultDataSource[i];
          dataSource.sensitive = tableResults[i].mic;
          dataSource.resistant = tableResults[i + 1].mic;
          dataSource.mediated = tableResults[i + 2].mic;
          if (dataSource.sensitive == 0) {
            dataSource.sensitive = "-";
          }
          if (dataSource.resistant == 0) {
            dataSource.resistant = "-";
          }
          if (dataSource.mediated == 0) {
            dataSource.mediated = "-";
          }
        }

        for (i = 1; i < tableResults.length; i += 3) {
          const dataSource = this.resultDataSource[i];
          dataSource.sensitive =
            Math.round(100 * tableResults[i - 1].time) / 100;
          dataSource.resistant = Math.round(100 * tableResults[i].time) / 100;
          dataSource.mediated =
            Math.round(100 * tableResults[i + 1].time) / 100;
          if (dataSource.sensitive == 0) {
            dataSource.sensitive = "-";
          }
          if (dataSource.resistant == 0) {
            dataSource.resistant = "-";
          }
          if (dataSource.mediated == 0) {
            dataSource.mediated = "-";
          }
        }

        for (i = 2; i < tableResults.length; i += 3) {
          const dataSource = this.resultDataSource[i];
          dataSource.sensitive =
            Math.round(100 * tableResults[i - 2].percentage) / 100;
          dataSource.resistant =
            Math.round(100 * tableResults[i - 1].percentage) / 100;
          dataSource.mediated =
            Math.round(100 * tableResults[i].percentage) / 100;
          if (dataSource.sensitive == 0) {
            dataSource.sensitive = "-";
          }
          if (dataSource.resistant == 0) {
            dataSource.resistant = "-";
          }
          if (dataSource.mediated == 0) {
            dataSource.mediated = "-";
          }
        }

        if (!res.charts || !res.monitorings || !res.advice) {
          console.log("res.charts: ", res.charts);
        } else {
          console.log("res.charts: ", res.charts);
          CurveFitting.setData(res.charts, res.monitorings, res.advice.mic);

          this.option = null;
          this.option = CurveFitting.getOptions();
          console.log("this.option: ", this.option);
          console.log("this.$refs: ", this.$refs);
          if (this.$refs.mychart) {
            this.$refs.mychart.refreshOption();
          }
        }
        this.onSolveSucess();
      } catch (error) {
        this.onSolveError(error);
      }
      // }
    },
    // async onDownload() {
    //   const link = document.createElement("a");
    //   link.href = await this.getReportPdf(this.data.id);
    //   link.click();
    // },
  },
};
</script>

<style scoped lang="scss">
.til {
  display: flex;
  align-items: center;

  img {
    width: 28px;
    margin-right: 10px;
  }
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  padding: 30px 0;
}
::v-deep .ant-descriptions-item-label,
::v-deep .ant-descriptions-item-content {
  color: #333333;
  font-size: 16px;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-view {
  border-radius: 20px;
  border: 1px solid #cccccc;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-content,
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  border-right: 1px solid #cccccc;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-item-label {
  background: #eeeeee;
  font-size: 16px;
  color: #333333;
}
::v-deep .ant-descriptions-bordered .ant-descriptions-row {
  border-bottom: 1px solid #cccccc;
  height: 70px;
}

::v-deep .ant-btn-primary {
  width: 130px;
  height: 58px;
  background: #3a36db;
  border-radius: 15px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
::v-deep .ant-table-small > .ant-table-content > .ant-table-body {
  // margin: 0;
}
::v-deep .ant-table-small {
  border: none;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
  padding: 7px 0;
}
::v-deep .ant-table-tbody > tr > td {
  border-bottom: none;
}
::v-deep .ant-input-number {
  font-size: 16px;
  height: 70px;
  line-height: 70px;
  border: none;
}
::v-deep .ant-input-number-sm input {
  padding: 0 10px;
}
::v-deep .ant-descriptions-item-content {
  padding: 0 !important;
}
::v-deep .ant-input-number-sm input {
  height: 70px;
}
</style>
